import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const BlogCard = ({ title, excerpt, image, author, date, readMoreLink }) => {
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Whether animation should happen only once
        });
    }, []);

    return (
        <div data-aos="fade-up" className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow">
            {/* Blog image */}
            <img
                src={image}
                alt={title}
                className="w-full h-48 object-cover rounded-md mb-4"
            />
            {/* Blog title */}
            <h3 className="text-xl font-bold text-gray-800 mb-2">{title}</h3>
            
            {/* Blog author and date */}
            <div className="text-gray-600 mb-4">
                <p>By <span className="font-semibold">{author}</span></p>
                <p className="text-sm">{date}</p>
            </div>
            
            {/* Blog excerpt */}
            <p className="text-gray-600 mb-4">{excerpt}</p>

            {/* Read more button */}
            <a
                href={readMoreLink}
                target="_blank"
                className="inline-block bg-purple-700 text-white py-2 px-4 rounded hover:bg-purple-800 transition-colors"
            >
               {title === "Get in Touch with Us" ? "Join us" : "Read More"} 
            </a>
        </div>
    );
};

export default BlogCard;
